import { AuthStorageKey } from '../localStorage/localStorageKey'

const { ORGANIZATION, STORE } = AuthStorageKey

// We refer AuthStorageKey here
// because I want sessionKey sync with localStorageKey
// so that even the localStorageKey value changes
// this sessionKey still works out of the box
export const AuthSessionKey = {
  ORGANIZATION,
  STORE,
}

export const ListSettingKey = {
  PRODUCT: 'PRODUCT_SETTINGS',
  PERFORMANCE_PRODUCTS: 'PERFORMANCE_PRODUCTS',
  COUPON: 'COUPON_SETTINGS',
  COVA_COUPON: 'COVA_COUPON_SETTINGS',
  GREENLINE_COUPON: 'GREENLINE_COUPON_SETTINGS',
  FLOWHUB_COUPON: 'FLOWHUB_COUPON_SETTINGS',
  LIGHTSPEED_COUPON: 'LIGHTSPEED_COUPON_SETTINGS',
  CATEGORY: 'CATEGORY_SETTINGS',
  SHOPIFY_CATEGORY: 'SHOPIFY_CATEGORY_SETTINGS',
  TAG: 'TAG_SETTINGS',
  SKU: 'SKU-management',
  PROMOTION: 'PROMOTION_SETTINGS',
  ATTRIBUTE: 'ATTRIBUTE_SETTINGS',
  COMMENT: 'COMMENT_SETTINGS',
  ORDER: 'ORDER_SETTINGS',
  SHOPIFY_ORDER: 'SHOPIFY_ORDER_SETTINGS',
  CUSTOMER: 'CUSTOMER_SETTINGS',
  INVENTORY: 'INVENTORY_SETTINGS',
  MANAGE_POINT: 'MANAGE_POINT',
  POINT_LOG: 'POINT_LOG',
  INVENTORY_ADJUSTMENT: 'INVENTORY_ADJUSTMENT',
  COVA_ORDER: 'COVA_ORDER_SETTINGS',
  COVA_ORDER_V2: 'COVA_ORDER_SETTINGS_V2',
  POS_COVA_ORDER_V2: 'POS_COVA_ORDER_SETTINGS_V2',
  GREENLINE_ORDER_V2: 'GREENLINE_ORDER_SETTINGS_V2',
  POS_GREENLINE_ORDER_V2: 'POS_GREENLINE_ORDER_SETTINGS_V2',
  FLOWHUB_ORDER: 'FLOWHUB_ORDER_SETTINGS',
  POS_FLOWHUB_ORDER: 'POS_FLOWHUB_ORDER_SETTINGS',
  LIGHTSPEED_ORDER: 'LIGHTSPEED_ORDER_SETTINGS',
  POS_LIGHTSPEED_ORDER: 'POS_LIGHTSPEED_ORDER_SETTINGS',
  COVA_CUSTOMER: 'COVA_CUSTOMER_SETTINGS',
  COVA_PRODUCT: 'COVA_PRODUCT_SETTINGS',
  COVA_PRODUCT_V2: 'COVA_PRODUCT_SETTINGS_V2',
  FLOWHUB_PRODUCT: 'FLOWHUB_PRODUCT_SETTINGS',
  LIGHTSPEED_PRODUCT: 'LIGHTSPEED_PRODUCT_SETTINGS',
  GREENLINE_PRODUCT: 'GREENLINE_PRODUCT_SETTINGS',
  GREENLINE_PRODUCT_V2: 'GREENLINE_PRODUCT_SETTINGS_V2',
  GREENLINE_ORDER: 'GREENLINE_ORDER_SETTINGS',
  GREENLINE_CUSTOMER: 'GREENLINE_CUSTOMER_SETTINGS',
  SHOPIFY_CUSTOMER: 'SHOPIFY_CUSTOMER_SETTINGS',
  SHOPIFY_PRODUCT: 'SHOPIFY_PRODUCT_SETTINGS',
  POSTAL_CODE: 'POSTAL_CODE_SETTINGS',
  DISTANCE_RADIUS: 'DISTANCE_RADIUS_SETTINGS',
  DRAWN_ZONE: 'DRAWN_ZONE_SETTINGS',
  FLOWHUB_CUSTOMER: 'FLOWHUB_CUSTOMER_SETTINGS',
  EMAIL_TEMPLATE: 'EMAIL_TEMPLATE_SETTINGS',
}

export const Notification = {
  APP_UPDATED: 'APP_UPDATED',
}
